<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-10 10:04:51
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-03 10:51:46
-->
<template>
  <div>
    <el-drawer
      title="查看约稿"
      :visible.sync="visibleTwo"
      @closed="closeTwo"
      :destroy-on-close="true"
      size="535px"
      :with-header="true"
    >
       <a-spin :spinning="appLoading">
    <div class="applay-box">
      <div>
        <div class="title">
          <div class="icon-title"></div>
          <div class="title-txt">约稿信息</div>
        </div>
        <div class="txt-box">
        <div class="txt">约稿状态</div>
        <div class="txt-two">
            {{dataOne.state==1?'待发送':dataOne.state==2?'待投稿':'已完成'}}
        </div>
      </div>
        <div class="txt-box">
        <div class="txt">约稿标题</div>
        <div class="txt-two">{{dataOne.title}}</div>
      </div>
      
       <div class="txt-box">
        <div class="txt">约稿单位</div>
        <div class="txt-two">
         {{dataOne.unit}}
        </div>
      </div>
      <div class="txt-box">
        <div class="txt">约稿时间</div>
        <div class="txt-two">
         {{dataOne.reservationTime}}
        </div>
      </div>
      <div class="txt-box">
        <div  class="txt">反馈时间</div>
        <div class="txt-two">
         {{dataOne.feedbackTime}}之前
        </div>
      </div>
      <div class="txt-box">
        <div class="txt">报送途径</div>
        <div class="txt-two">
         {{dataOne.road}}
        </div>
      </div>
      <div class="txt-box">
        <div class="txt">联系人</div>
        <div class="txt-two">
         {{dataOne.contacts}}
        </div>
      </div>
       <div class="txt-box">
        <div class="txt">联系电话</div>
        <div class="txt-two">
           {{dataOne.phone}}
        </div>
      </div>
       <div class="txt-box">
        <div class="txt">约稿信息</div>
        <div class="txt-two">
         {{dataOne.information}}
        </div>
      </div>
       <div class="txt-box">
        <div class="txt">发布人</div>
        <div class="txt-two">
         {{dataOne.releaseUser}}
        </div>
      </div>
       <div class="txt-box">
        <div class="txt">发布时间</div>
        <div class="txt-two">
        {{dataOne.releaseTime}}
        </div>
      </div>
    </div>
    
     <div>
        <div class="title">
          <div class="icon-title"></div>
          <div class="title-txt">投稿情况</div>
        </div>
        <div class="txt-box">
        <div class="txt-two">
            <coententTable
              :y="350"
              :columns="columns"
              :dataSource="dataSource"
              :customSlot="customSlot"
     
    >
     <template v-slot:state="scopeVal">
          <span style="color:#F56C6C" v-if="scopeVal.scope.flagSubmit == 1">未投稿</span>
          <span v-else>已投稿</span>
     </template>
    </coententTable>
        </div>
      </div>
    </div>
    </div>
  </a-spin>
    </el-drawer>
  </div>
</template>

<script>
import {selectViewData}  from './index';
import coententTable from "@/components/coentent_table.vue";
export default {
  data() {
    return {
      visibleTwo: false,
      appLoading: false,
      dataOne:{},
      dataSource: [],
       columns: [
         {
          title: "承办单位",
          dataIndex: "orgName",
          width: 300,
        },
        {
          title: "投稿状态",
          dataIndex: "flagSubmit",
          scopedSlots: { customRender: "state" },
          width: 120,
        }
      ],
      customSlot: [
        {
          name: "state",
          customRender: "state",
        },
      ],
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    item:{
      type:Object,
      default:{},
    },
  },
  components: {
    coententTable
  },
  mounted() {},
  methods: {
    closeTwo() {
      this.$emit('closeTwo')
    },
    deils(){
      this.appLoading  = true;
      selectViewData({
          id:this.item.id
      }).then((res)=>{
          if(res.code == 0){
            this.dataOne = res.data;
            this.dataSource = res.data.unitResponses;
            this.appLoading  = false;
          }
      })
    }
  },
  created() {},
  watch: {
    visible(val) {
      this.visibleTwo = val;
      if(this.visibleTwo){
        this.deils()
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-drawer__header {
  border-bottom: solid 1px #ededef;
  padding-bottom: 10px;
  padding-top: 10px;
  color: #000;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 14px;
}
.el-drawer__close-btn {
  font-size: 14px;
}
/deep/ .el-drawer {
  border-top-left-radius: 13px;
  border-bottom-left-radius: 13px;
}
/deep/ .el-icon-close {
  font-weight: 600;
}
.applay-box {
  padding: 24px;
  padding-bottom: 20px;
  padding-top: 0px;
  padding-bottom: 100px;
}
.title {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .icon-title {
    width: 4px;
    height: 18px;
    border-radius: 2px;
    background-color: rgba(23, 109, 230, 1);
  }
  .title-txt {
    color: rgba(23, 109, 230, 1);
    font-size: 16px;
    font-family: HarmonyOS_Sans_SC-regular;
    margin-left: 10px;
    font-weight: 600;
  }
}
.txt {
  color: rgba(48, 49, 51, 1);
  font-size: 14px;
  font-family: HarmonyOS_Sans_SC-bold;
  font-weight: 600;
  width: 80px;
}
.txt-two {
  color: rgba(48, 49, 51, 1);
  font-size: 14px;
  font-family: HarmonyOS_Sans_SC-regular;
  width: 100%;
}
.txt-box {
  margin-bottom: 20px;
  display: flex;
}
.txt-two-img {
  width: 90px;
  height: 90px;
  margin-right: 14px;
  background: #f6f6f6;
  /deep/ .el-image__inner {
    object-fit: contain;
  }
}
/deep/ .el-descriptions--medium.is-bordered .el-descriptions-item__cell {
  padding: 8px;
  &:first-child {
    width: 120px;
  }
}
.label-box {
  width: 300px;
}
/deep/ .table{
  margin: 0px;
}
</style>